class Letter_Validation {
	constructor() {
		this.selectors = {
			document: document,
			inputLetter: '.js-only-letter'
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {		
		this.nodes.inputLetter.keypress(event => (event.key).match(/^[A-Za-zȘȚÎĂÂșțăîâа-яА-ЯёЁ\s]+$/) ? true : false)
    }
}
new Letter_Validation();